import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development settings routes.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentSettingsRoute = defineRoute(`${developmentRoute.path}/settings`);
export const developmentFeatureFlagTestRoute = defineRoute(`${developmentRoute.path}/feature-flag-test`);
